import { useEffect, useState } from 'react'
import { setDialogListener } from '../../services/dialogService'
import { useTranslation } from '../../i18n/LanguageContext'
import './Dialog.css'

function DialogContainer() {
  const [state, setState] = useState(null)
  const { t } = useTranslation()

  useEffect(() => {
    setDialogListener((config) => setState(config))
    return () => setDialogListener(null)
  }, [])

  const handleClose = (result) => {
    if (state?.resolve) state.resolve(result)
    setState(null)
  }

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      if (state?.type === 'alert') handleClose()
      else if (state?.type === 'confirm') handleClose(false)
    }
  }

  if (!state) return null

  const isAlert = state.type === 'alert'
  const title = state.title || (isAlert ? t('dialog.information') : t('dialog.confirm'))

  return (
    <div className="dialog-overlay" onClick={handleOverlayClick} role="dialog" aria-modal="true" aria-labelledby="dialog-title" aria-describedby="dialog-message">
      <div className="dialog-box" onClick={(e) => e.stopPropagation()}>
        <h2 id="dialog-title" className="dialog-title">{title}</h2>
        <p id="dialog-message" className="dialog-message">{state.message}</p>
        <div className={`dialog-actions ${isAlert ? 'dialog-actions--single' : ''}`}>
          {isAlert ? (
            <button type="button" className="dialog-btn dialog-btn-primary" onClick={() => handleClose()}>
              {t('dialog.ok')}
            </button>
          ) : (
            <>
              <button type="button" className="dialog-btn dialog-btn-secondary" onClick={() => handleClose(false)}>
                {state.cancelLabel || t('dialog.cancel')}
              </button>
              <button
                type="button"
                className={`dialog-btn ${state.variant === 'danger' ? 'dialog-btn-danger' : 'dialog-btn-primary'}`}
                onClick={() => handleClose(true)}
              >
                {state.confirmLabel || t('dialog.confirm')}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default DialogContainer
